import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeTab: "Information",
  toggle: false,
  isCellPreviewOpen: false,
  // 지도에 띄워 둔 촬영 회차. 데이터 탭의 회차 목록과 지도의 시간 드롭다운이
  // 같은 값을 보게 하려고 여기 둔다.
  //   { missionLogId, date: "YYYY-MM-DD", time: "HH:mm", at }
  // at 은 같은 회차를 다시 눌러도 지도 쪽 효과가 다시 돌게 하는 값이다.
  diagnosisFocus: null,
};

const tabSlice = createSlice({
  name: "tab",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setToggle: (state, action) => {
      state.toggle = action.payload;
      // 진단 모드를 끄면 보고 있던 회차도 같이 놓는다. 안 그러면 데이터 탭에서
      // "지도에 표시 중"이 그대로 남아, 꺼진 지도와 어긋난다.
      if (!action.payload) state.diagnosisFocus = null;
    },
    setCellPreviewOpen: (state, action) => {
      state.isCellPreviewOpen = action.payload;
    },
    // 회차를 고르는 것과 진단 모드를 켜는 것은 늘 같이 일어난다.
    // 두 곳(데이터 탭 · 지도 드롭다운)에서 부르는 값이라 한 액션으로 묶어 둔다.
    setDiagnosisFocus: (state, action) => {
      state.diagnosisFocus = action.payload ?? null;
      state.toggle = Boolean(action.payload);
    },
    // 모드는 켜 둔 채 표시만 내린다. 고른 날짜에 회차가 없어 지도에 아무것도
    // 안 떠 있을 때 쓴다 — 그 상태로 두면 데이터 탭만 "지도에 표시 중"이 남는다.
    clearDiagnosisFocus: (state) => {
      state.diagnosisFocus = null;
    },
  },
});

export const {
  setActiveTab,
  setToggle,
  setCellPreviewOpen,
  setDiagnosisFocus,
  clearDiagnosisFocus,
} = tabSlice.actions;
export default tabSlice.reducer;
